import { render, staticRenderFns } from "./IsPowdercoatingPossibleDialog.vue?vue&type=template&id=bb23b868"
import script from "./IsPowdercoatingPossibleDialog.vue?vue&type=script&lang=ts"
export * from "./IsPowdercoatingPossibleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports